import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {Breadcrumb} from 'antd';

class breadcrumbCustomer extends Component{
    render(){
       // console.log(this.props)
        const first = <Breadcrumb.Item >
            {this.props.first}
        </Breadcrumb.Item> || '';
        const second = <Breadcrumb.Item>{this.props.second}</Breadcrumb.Item> || '';
        return(
            <>
             <Breadcrumb style = {{ margin: '16px 0' }}>
                <Breadcrumb.Item>
        {            <Link to = {'/user'}>Home</Link>}
                </Breadcrumb.Item>
                {first}
                {second}
            </Breadcrumb> 
            </>
        );
    }
}

export default breadcrumbCustomer;
